export interface WalkthroughStep {
  target: string | null; // data-walkthrough value, null = centered modal (no spotlight)
  title: string;
  description: string;
  placement: "top" | "bottom" | "left" | "right" | "center";
  route: string; // which page this step lives on
}

export const WALKTHROUGH_STEPS: WalkthroughStep[] = [
  // --- /add (Translate page) ---
  {
    target: "translate-card",
    title: "Translate Words",
    description:
      "This is your main tool. Type any Hebrew or English word, hit Translate, and save it to your word bank. You can organize words into categories manually, or let Pro auto-categorize them for you.",
    placement: "bottom",
    route: "/add",
  },
  {
    target: "translate-swap",
    title: "Swap Languages",
    description:
      "Tap here to switch between Hebrew\u2192English and English\u2192Hebrew. Works both ways!",
    placement: "bottom",
    route: "/add",
  },
  {
    target: "translate-mode-toggle",
    title: "Chop It Up",
    description:
      "Got a WhatsApp message or email in Hebrew? Paste it here and \u201cChop It Up\u201d breaks it into individual words you can save to your word bank.",
    placement: "bottom",
    route: "/add",
  },
  {
    target: "translate-engine",
    title: "Google vs AI Translation",
    description:
      "Google Translate is instant and free for everyone. Upgrade to Pro to unlock AI translations \u2014 more natural, context-aware, and great for tricky phrases.",
    placement: "bottom",
    route: "/add",
  },

  // --- /words (Word Bank) ---
  {
    target: "wordbank-search",
    title: "Search & Sort",
    description:
      "Find any word by Hebrew, English, or category. Sort by date added, last reviewed, or strength to focus on what matters.",
    placement: "bottom",
    route: "/words",
  },
  {
    target: "wordbank-card",
    title: "Your Words",
    description:
      "Tap any word to see its translation, categories, and notes. Pro unlocks full grammar tables, conjugations, and example sentences.",
    placement: "bottom",
    route: "/words",
  },

  // --- /practice (Review) ---
  {
    target: "nav-practice",
    title: "Spaced Repetition",
    description:
      "Review your words with smart flashcards. Shoresh uses spaced repetition \u2014 words you struggle with come back sooner, words you know well space out over days.",
    placement: "bottom",
    route: "/practice",
  },

  // --- /scenarios (Study Sets) ---
  {
    target: "scenarios-header",
    title: "Scenarios",
    description:
      "Organize vocab by real-life situations \u2014 like \u201cAt the Doctor\u201d or \u201cJob Interview.\u201d Pro users can have AI generate starter words for any scenario.",
    placement: "bottom",
    route: "/scenarios",
  },

  // --- Back to nav ---
  {
    target: "nav-stats",
    title: "Track Your Progress",
    description:
      "Your daily streak and mastered word count live here. Tap to see detailed stats on your learning journey.",
    placement: "bottom",
    route: "/scenarios", // stays on current page, targets nav
  },

  // --- Final (no spotlight) ---
  {
    target: null,
    title: "You\u2019re All Set!",
    description:
      "Start adding words and building your Hebrew vocabulary. You can replay this tour anytime from your profile menu.",
    placement: "center",
    route: "/add",
  },
];
